import React, {useCallback, useMemo, useState} from 'react';
import {v4 as uuidv4} from 'uuid';

import {SettingLabel} from '../components/SettingLabel';
import {BucketCustomization, SemanticLegendSettings} from '../types';
import {BucketCustomizationInput} from './BucketCustomizationInput';
import {SemanticLegendBucketsActions} from './SemanticLegendBucketsActions';
export type SemanticLegendBucketCustomizationProps = {
  buckets: BucketCustomization[];
  bucketCustomizations: Record<number, BucketCustomization>;
  updateSetting: (settings: Partial<SemanticLegendSettings>) => void;
};

export const SemanticLegendBuckets = ({
  buckets,
  bucketCustomizations,
  updateSetting,
}: SemanticLegendBucketCustomizationProps) => {
  const ids = useMemo(() => buckets.map(_i => uuidv4()), [buckets]);

  const updateBucketCustomizationSetting = useCallback(
    (settings: Partial<BucketCustomization>, index: number) => {
      const newBucketCustomizations = {...bucketCustomizations};
      newBucketCustomizations[index] = {
        ...newBucketCustomizations[index],
        ...settings,
      };
      updateSetting({
        bucketCustomizations: newBucketCustomizations,
        buckets: buckets,
      });
    },
    [updateSetting, buckets, bucketCustomizations]
  );

  const bucketCustomizationList = buckets?.map((bucket, index) => (
    <li key={ids[index]}>
      <BucketCustomizationInput
        bucket={bucket}
        bucketCustomization={bucketCustomizations[index] ?? {}}
        index={index}
        numberOfBuckets={buckets?.length}
        updateBucketSetting={(settings: Partial<BucketCustomization>) =>
          updateBucketCustomizationSetting(settings, index)
        }
      />
    </li>
  ));

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex flex-col gap-20">
      <div className="flex w-full gap-20">
        <SettingLabel text="Buckets" className="flex w-2/3" />
        <SemanticLegendBucketsActions setIsOpen={setIsOpen} isOpen={isOpen} />
      </div>
      <ul className="flex flex-col gap-20">{bucketCustomizationList}</ul>
    </div>
  );
};
